module.exports = __webpack_public_path__ + "fonts/seguisli.3b10d164.ttf";